window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#accessibleNav'),

    // Product Page
    $productImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    $productImageZoomUrl: $('.js-product-photo img').attr('data-zoom-image')
  }
};

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.responsiveVideos();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul');
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav--dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.productImageSwitch = function () {
  if ( timber.cache.$thumbImages.length ) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href'),
          newZoomImage = $(this).attr('data-zoom-image'); // zoom img url

      timber.switchImage(newImage, null, timber.cache.$productImage);

      
        timber.switchZoomImage(newZoomImage, null, timber.cache.$productImage);

        $(".js-product-photo").trigger('zoom.destroy').zoom({
          url: newZoomImage
        });
      
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.switchZoomImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('data-zoom-image', src);

};

timber.responsiveVideos = function () {
  $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
  $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

// Initialize Timber's JS on docready
$(timber.init)

//
// Custom JS
// -----------------------------------------------------------------------------

// Variables
var sidebar = $('.js-sidebar'),
    sidebarButton = $('.js-sidebar-button'),
    footerCol = $('.site-footer .js-footer-col'),
    brandsLinkList = $('.brands__link-list'),
    deviceWidth = $(window).width(),
    deviceHeight = $(window).height(),
    sidebarWidth = 270;

// Update devicewidths on resize
$(window).resize(function(){
  deviceWidth = $(window).width(),
  deviceHeight = $(window).height();
});

//
// Show popup to visitors
// If closed or submitted then don't show again
// -----------------------------------------------------------------------------
var promo_popup = function() {

  var emailPopup = $('.email-popup'),
      close = emailPopup.find('.email-popup__close'),
      form = emailPopup.find('form');

  function closePopup() {
    emailPopup.hide();
    localStorage.setItem('popup', true );
  }

  if(emailPopup && !localStorage.popup) {
    emailPopup.show();
  } else {
    emailPopup.hide();
  }

  close.on('click', function(){
    closePopup();
  });

  form.on('submit', function(){
    closePopup();
  });

}

// Change icon on element
var changeIcon = function(el, oldIcon, newIcon){
  el.removeClass('icon-' + oldIcon);
  el.addClass('icon-' + newIcon);
}

// add overlay to site
var overlay = function(el, task){
  if(task.toLowerCase() == 'show'){
    el.after('<div class="overlay"></div>');
  }
  if(task.toLowerCase() == 'hide') {
    el.next('.overlay').remove();
  }
}

//
// Show sidebar
// -----------------------------------------------------------------------------
var showSidebar = function(){
  var pageHeight = $(document).height();


  //slide button across
  $(sidebarButton).animate({
    left: sidebarWidth
  });
  // slide out sidebar
  $(sidebar).animate({
    left: 0
  }, function(){
    // Switch Icon to X
    changeIcon($(sidebarButton).find('i'), 'navicon', 'times');

  }).addClass('open');

  $(sidebar).css('height', pageHeight);

  // remove event listener
  $(sidebarButton).unbind('click');
  // add hideSidebar to button
  $(sidebarButton).on('click', hideSidebar);

  // show overlay
  overlay(sidebar, 'show');
}

//
// Hide sidebar
// -----------------------------------------------------------------------------
var hideSidebar = function(){
  $(sidebar).animate({
    left: '-' + sidebarWidth
  }, function(){
    $(this).removeClass('open');
  });

  // slide button across
  $(sidebarButton).animate({
    left: 0
  }, function(){
    // hide overlay
    overlay(sidebar, 'hide')

    // Switch Icon back to burger
    changeIcon($(sidebarButton).find('i'), 'times', 'navicon');
  });

  // remove event listener
  $(sidebarButton).unbind('click');
  // add showSidebar to button
  $(sidebarButton).on('click', showSidebar);

}

//
// Expanding search
// -----------------------------------------------------------------------------
var expandingSearch =  function(){
  // some variables
  var searchToggle = $('.header-links .js-search-button-toggle'),
      searchBar = $('.header-links .js-search-bar'),
      searchInput = $('.header-links .js-search-bar input[type="search"]'),
      toggleInd = false;

  function hideSearch() {
    searchBar.stop().animate({
      width: '0'
    }, function(){
      $(this).hide();
    });
  }

  // When search icon is clicked slide search input out
  searchToggle.on('click', function(e){
    e.preventDefault;

    // Find total width of menu items under search
    var getMenuWidth = function() {

      // Get elements and create array
      var totalWidth,
          cartMenuItemsObj = $('[class^="header-links__"]'),
          cartMenuItemsArr = $.makeArray(cartMenuItemsObj);

      // get widths of each item in the array and add to new array using map()
      var cartMenuWidths = cartMenuItemsArr.map(function(currentValue, index) {
        return currentValue.offsetWidth;
      });

      // total up all widths in new array
      var cartMenuTotalWidth = cartMenuWidths.reduce(function(a, b){
        return a + b;
      });

      // return totalWidth of all elements in menu
      return cartMenuTotalWidth;
    };

    // Add 20px on to cover the extra width
    var searchWidth = getMenuWidth() + 20;

    if(toggleInd == false){
      // If closed, open
      toggleInd = true;

      searchBar.stop().show().animate({
        width: searchWidth
      })
    } else {
      // If open, close
      toggleInd = false;

      hideSearch();
    }
  })

  // On focus hide toggle icon
  searchInput.on('focus', function(){
    $(this).on('keyup', function(){
      // Check if something is entered and hide the toggle button if so
      if($(this).val().length > 0) {
        searchToggle.css('visibility', 'hidden');
      } else {
        searchToggle.css('visibility', 'visible');
      }
    })
  })

}

// Show popup if first time
promo_popup();


//
// Wait until DOM is loaded
// -----------------------------------------------------------------------------

$(document).ready(function(){

  

    // Initialise home slider
    $('.js-homeslider').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: false,
      fade: true
    });

  

  
    $(".js-product-photo").zoom({
      url: timber.cache.$productImageZoomUrl
    });
  

  // Expanding Search bar
  expandingSearch();


  // Accordian footer mobile
  //
  // On page load
  if(deviceWidth < 769){
    tcc.component.verticalSlider(footerCol);
  }
  // On resize
  $(window).resize(function(){
    if(deviceWidth < 769) {
      footerCol.unbind();
      tcc.component.verticalSlider(footerCol);
    } else {
      footerCol.unbind().find('> ul').css('display', '');
    }
  });

  // Accordian Brands
  //
  // On page load
  if(deviceWidth < 769){
    tcc.component.verticalSlider(brandsLinkList);
  }
  // On Resize
  $(window).resize(function(){
    if(deviceWidth < 769) {
      brandsLinkList.unbind();
      tcc.component.verticalSlider(brandsLinkList);
    } else {
      brandsLinkList.unbind().find('> ul').css('display', '');
    }
  });


  //
  // Sidebar
  // ---------------------------------------------------------------------------

  // Show sidebar
  $(sidebarButton).on('click', showSidebar);


  //
  // Wishlist
  // Products grid in my acccount for wishlist need structural classes applied
  // ---------------------------------------------------------------------------
  var wishlist = $('.d4-d12'),
      productItem = $('.d4-d12 .product'),
      productTitle = productItem.find('.title'),
      productPrice = productItem.find('.price'),
      shareBox = $('.share-the-wishy');

  // add product grid class to wrapper
  wishlist.addClass('product-grid grid');

  // Css grid classes for product items
  productItem.addClass('grid-item large--one-quarter medium--one-half clearfix');

  // styling for product item title and price
  productTitle.addClass('h6');
  productPrice.css({
    'font-weight': 'normal'
  });

  // clear floats on share section
  shareBox.css('clear', 'both');

});


//
// Wait until everything has loaded
// -----------------------------------------------------------------------------
$(window).load(function(){

  // Social buttons
  $('.social-share').show();

});

